/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmbeddingGenerationStatus } from '../models/EmbeddingGenerationStatus';
import type { Page_ImagePredictionWithImageAndClassificationResponse_ } from '../models/Page_ImagePredictionWithImageAndClassificationResponse_';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PredictionService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Image Predictions
     * @returns Page_ImagePredictionWithImageAndClassificationResponse_ Successful Response
     * @throws ApiError
     */
    public getImagePredictions({
        sortBy = 'probability',
        url,
        embeddingGenerationStatus,
        imageId,
        sources,
        extraJsonpathExclude,
        extraJsonpathInclude,
        classificationName,
        classificationType,
        classificationId,
        classificationHasImages,
        page = 1,
        size = 50,
    }: {
        sortBy?: 'probability' | 'created_dt',
        url?: string,
        embeddingGenerationStatus?: EmbeddingGenerationStatus,
        imageId?: string,
        sources?: Array<string>,
        extraJsonpathExclude?: string,
        extraJsonpathInclude?: string,
        classificationName?: string,
        classificationType?: string,
        classificationId?: string,
        classificationHasImages?: boolean,
        page?: number,
        size?: number,
    }): CancelablePromise<Page_ImagePredictionWithImageAndClassificationResponse_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/prediction/image',
            query: {
                'sort_by': sortBy,
                'url': url,
                'embedding_generation_status': embeddingGenerationStatus,
                'image_id': imageId,
                'sources': sources,
                'extra_jsonpath_exclude': extraJsonpathExclude,
                'extra_jsonpath_include': extraJsonpathInclude,
                'classification_name': classificationName,
                'classification_type': classificationType,
                'classification_id': classificationId,
                'classification_has_images': classificationHasImages,
                'page': page,
                'size': size,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
